import { GETTERS, STATE } from "./names";
import { State } from "./types";

export default {
    [GETTERS.BANNERS] (state: State) {
        return state[STATE.BANNERS];
    },
};